// @flow
import Properties from "../../../Properties";
import { getInit, postInit, graphQLInit } from "../../global/types/constants";
import type { DispatchType } from "../../global/types/redux";
import {
  CompanyNode,
  CompanyAdminNode,
  LicenceNode
} from "../../account/types/GraphQlNodes";
import { apiFailCallbackHandle } from "../../account/containers/ErrosDisplay";
import {
  ADMIN_GET_COMPANY_LIST,
  ADMIN_UPDATE_COMPANY_LIST,
  ADMIN_UPDATE_COMPANY_LICENCE,
  ADMIN_UPDATE_COMPANY_FACEBASE,
  ADMIN_UPDATE_COMPANY_USER,
  ADMIN_UPDATE_COMPANY_CHILD,
  ADMIN_UPDATE_TIER,
  ADMIN_DELETE_LICENCE_FROM_COMPANY,
  ADMIN_REMOVE_COMPANY_ITEM
} from "../../global/actions/actionNames";

const root = Properties.api_root;

export const updateAdminCompanyUser = (companyId: string, user: *): * => (
  dispatch: DispatchType
) => {
  dispatch({
    type: ADMIN_UPDATE_COMPANY_USER,
    data: user,
    companyId: companyId
  });
};

export const fetcCompanyList = (callback?: Function): * => (
  dispatch: DispatchType
): * => {
  const graphQl = `
  {
    allCompanies {
      ${CompanyAdminNode}
    }
  }
  `;
  return fetch(`${root}/api/v2/company/graphql`, graphQLInit(graphQl))
    .then(response => response.json())
    .then(json => {
      dispatch({
        type: ADMIN_GET_COMPANY_LIST,
        companies: json.data.allCompanies
      });
      callback && callback(json.data.allCompanies);
    });
};

export const fetchTierList = (callback?: Function): * => (
  dispatch: DispatchType
): * => {
  const graphQl = `
  {
    tiers {
      uuid
      name
      id
    }
  }
  `;
  return fetch(`${root}/api/v2/company/graphql`, graphQLInit(graphQl))
    .then(response => response.json())
    .then(json => {
      if (json.data.tiers.length === 0) {
        dispatch({ type: ADMIN_UPDATE_TIER, tier: null });
      } else {
        json.data.tiers.forEach(tier => {
          dispatch({ type: ADMIN_UPDATE_TIER, tier: tier });
        });
      }
      callback && callback(json.data.tiers);
    });
};

export const deleteCompany = (
  companyId: string,
  doneCallback: Function,
  failCallBack: Function
): * => (dispatch: DispatchType): * => {
  const graphQl = `
  mutation {
    deleteCompany(companyId: "${companyId}"){
      ok
      errors {
        field
        message
      }
    }
  }
  `;
  return fetch(`${root}/api/v2/company/graphql`, graphQLInit(graphQl))
    .then(response => response.json())
    .then(json => {
      if (json.errors) {
        failCallBack && failCallBack(apiFailCallbackHandle(json.errors));
      } else {
        const result = json.data.deleteCompany;
        if (result.ok) {
          dispatch({ type: ADMIN_REMOVE_COMPANY_ITEM, companyId: companyId });
          doneCallback && doneCallback(result.facebase);
        } else {
          failCallBack && failCallBack(apiFailCallbackHandle(result.errors));
        }
      }
    })
    .catch(err => {
      failCallBack && failCallBack(apiFailCallbackHandle(err.message));
    });
};
